import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { TopSubnets } from './components/TopSubnets';
import { MindshareGainersLosers } from './components/MindshareGainersLosers';
import { WalletPage } from './pages/WalletPage';
import WalletDashboard from './components/WalletDashboard';
import MindshareHub from './pages/MindshareHub';
import SubnetPage from './pages/SubnetPage';
import BountyBoard from './pages/BountyBoard';
import BountyArchive from './pages/BountyArchive';
import BountyAnalytics from './pages/BountyAnalytics';
import TerminalPage from './pages/TerminalPage';
import AdminPage from './pages/AdminPage';
import TensorPulseMindshare from './pages/TensorPulseMindshare';
import KOLScanPage from './pages/KOLScanPage';
import KOLProfilePage from './pages/KOLProfilePage';
import DevPage from './pages/DevPage';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<TensorPulseMindshare />} />
        <Route path="/wallet/:address" element={<WalletPage />} />
        <Route path="/dashboard/:address" element={<WalletDashboard />} />
        <Route path="/mindshare" element={<MindshareHub />} />
        <Route path="/tensorpulse-mindshare" element={<TensorPulseMindshare />} />
        <Route path="/kolscan" element={<KOLScanPage />} />
        <Route path="/kolscan/:username" element={<KOLProfilePage />} />
        <Route path="/subnet/:netuid" element={<SubnetPage />} />
        <Route path="/bounties" element={<BountyBoard />} />
        <Route path="/bounties/archive" element={<BountyArchive />} />
        <Route path="/bounties/analytics" element={<BountyAnalytics />} />
        <Route path="/terminal" element={<TerminalPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/dev" element={<DevPage />} />
      </Routes>
    </Layout>
  );
}

export default App;